import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Box from '@material-ui/core/Box';

const SHORTHAND_OPERATORS = {
  is: '=',
  not_is: '!=',
  gt: '>',
  gte: '>=',
  lt: '<',
  lte: '<=',
  in: '=',
};

const FilterString = ({ name, operator, renderSettings, value }) => {
  const intl = useIntl();

  const getOperatorLabel = (operatorValue = 'is') => {
    if (renderSettings?.shorthandOperator && operatorValue !== 'between') {
      return SHORTHAND_OPERATORS[operatorValue] ?? SHORTHAND_OPERATORS.is;
    }

    if (!operatorValue) {
      return '';
    }

    return intl.formatMessage({
      id: `dataGrid.filterOperators.${operatorValue}`,
      defaultMessage: operatorValue,
      description: `Label of the operator ${operatorValue}`,
    });
  };

  if (operator === 'between') {
    const andLabel = intl.formatMessage({
      id: 'dataGrid.filterConjunctions.and',
      defaultMessage: 'And',
      description: 'Label of the conjunction and',
    });

    return (
      <Box display="flex" alignItems="center">
        <Box mr={0.7}>{name}</Box>
        <Box mr={0.7}>{getOperatorLabel(operator).toLowerCase()}</Box>
        <Box>
          {value?.[0] ?? '-'} {andLabel.toLowerCase()} {value?.[1] ?? '-'}
        </Box>
      </Box>
    );
  }

  if (operator === 'missing') {
    const valueLabel = intl.formatMessage({
      id: 'dataGrid.filterValues.noValue',
      defaultMessage: 'no value',
      description: 'Label of the no filter value label',
    });

    return (
      <Box display="flex" alignItems="center">
        <Box mr={0.7}>{name}</Box>
        <Box mr={0.7}>{getOperatorLabel(operator).toLowerCase()}</Box>
        {renderSettings?.shorthandOperator && <Box>{valueLabel}</Box>}
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center">
      <Box mr={0.7}>{name}</Box>
      <Box mr={0.7}>{getOperatorLabel(operator).toLowerCase()}</Box>
      <Box>{value}</Box>
    </Box>
  );
};

FilterString.propTypes = {
  name: PropTypes.string,
  operator: PropTypes.string,
  renderSettings: PropTypes.object,
  value: PropTypes.any,
};

FilterString.defaultProps = {
  name: '',
  operator: '',
  renderSettings: {},
  value: [],
};

export default FilterString;
